export enum EOpenSidebar {
  Settings = 'Settings',
  Knowledge = 'Knowledge',
}
